var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthIndexGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A1A1A1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310,460H190c-8.3,0-15-6.7-15-15l0,0c0-8.3,6.7-15,15-15h120c8.3,0,15,6.7,15,15l0,0 C325,453.3,318.3,460,310,460z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392.3,240.3l-118.2-8.2c-5.5-7.4-14.2-12.1-24.1-12.1c-16.6,0-30,13.4-30,30s13.4,30,30,30 c9.9,0,18.6-4.8,24.1-12.1l118.2-8.2c5.1-0.4,9-4.6,9-9.7C401.3,244.9,397.3,240.7,392.3,240.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,40C134,40,40,134,40,250c0,52.6,19.3,100.7,51.3,137.5c6.5,7.6,13.6,14.7,21.2,21.2l21.3-21.3 c-3.8-3.2-7.5-6.6-11.1-10.2c-3.6-3.6-7-7.3-10.2-11.1c-3.7-4.4-7.2-8.9-10.4-13.5l14.5-8.4c7.2-4.1,9.6-13.3,5.5-20.5v0 c-4.1-7.2-13.3-9.6-20.5-5.5l-14.5,8.4C75.9,303,70,277,70,250c0-27,5.9-53,17.1-76.7l14.5,8.4c7.2,4.1,16.3,1.7,20.5-5.5v0 c4.1-7.2,1.7-16.3-5.5-20.5l-14.5-8.4c6.1-8.7,12.9-16.9,20.6-24.6c30.4-30.4,69.9-48.6,112.3-52.1v16.7c0,8.3,6.7,15,15,15 s15-6.7,15-15V70.6c42.4,3.5,81.8,21.7,112.3,52.1c7.7,7.7,14.5,15.9,20.6,24.6l-14.5,8.4c-7.2,4.1-9.6,13.3-5.5,20.5v0 c4.1,7.2,13.3,9.6,20.5,5.5l14.5-8.4C424.1,197,430,223,430,250c0,27-5.9,53-17.1,76.7l-14.5-8.4c-7.2-4.1-16.3-1.7-20.5,5.5v0 c-4.1,7.2-1.7,16.3,5.5,20.5l14.5,8.4c-3.2,4.7-6.7,9.2-10.4,13.5c-3.2,3.8-6.6,7.5-10.2,11c-3.6,3.6-7.2,6.9-11,10.2l21.3,21.3 c7.6-6.6,14.6-13.6,21.2-21.2c32-36.8,51.3-84.9,51.3-137.5C460,134,366,40,250,40z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIndexGray);
export default __webpack_public_path__ + "static/media/Health-Index-Gray.cff5587a463873b296c8955ac07dc814.svg";
export { ForwardRef as ReactComponent };